import * as React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { displayDate } from "src/helpers";

const useStyles = makeStyles({
  noSignatureContainer: {
    border: "1px solid #dedede",
    borderRadius: 4,
    maxWidth: "100%",
    minHeight: 69,
    width: 256
  },
  noSignatureText: {
    color: "#a4a4a4",
    fontSize: "1.4rem"
  },
  signatureContainer: {
    color: "#4d4d4d",
    display: "table" as "table",
    maxWidth: "100%",
    minWidth: 256,
    tableLayout: "fixed" as "fixed",
    width: "100%"
  },
  signatureDate: {
    display: "table-cell" as "table-cell",
    fontSize: "1.4rem",
    height: 69,
    textAlign: "left" as "left",
    verticalAlign: "middle" as "middle",
    width: 80
  },
  signatureText: {
    display: "table-cell" as "table-cell",
    fontFamily: '"Caveat", cursive',
    fontSize: "3rem",
    height: 69,
    padding: "0 12px 0 0",
    verticalAlign: "middle" as "middle",
    wordWrap: "break-word" as "break-word"
  }
});

interface IOwnProps {
  dateSigned: Date | null;
  fullName: string;
}

const Signature = ({ dateSigned, fullName }: IOwnProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  if (dateSigned) {
    return (
      <div className={classes.signatureContainer}>
        <Typography className={classes.signatureText}>{fullName}</Typography>
        <Typography className={classes.signatureDate}>{displayDate(dateSigned)}</Typography>
      </div>
    );
  } else {
    return (
      <Grid className={classes.noSignatureContainer} justifyContent="center" alignItems="center" container>
        <Typography className={classes.noSignatureText}>{t(`feedback.page.talk-sheet.signatureAndDate`)}</Typography>
      </Grid>
    );
  }
};

export default React.memo(Signature);
